// extracted by mini-css-extract-plugin
export default {"loader":"CircleLoader-loader-mxC","spin":"CircleLoader-spin-rG1"};